import React from "react";
import SEO from "../components/SEO";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./css/Privacy.css";

const Terms = () => {
  return (
    <>
    <SEO
        title="Terms of Service - Joujo Safaris"
        description="These Terms of Service constitute a legally binding agreement between Joujo Safaris (“we,” “us,” or “our”) 
              and you (“the client,” “you,” or “your”). By accessing our website, booking a safari, or using any of our services, 
              you accept and agree to be bound by these Terms."
        url={`https://joujosafaris.com/terms`}
        image=""
        schema={{
          "@context": "https://schema.org",
          "@type": "TermsOfService",
          name: "Terms of Service - Joujo Safaris",
          description: `These Terms of Service constitute a legally binding agreement between Joujo Safaris (“we,” “us,” or “our”) 
              and you (“the client,” “you,” or “your”). By accessing our website, booking a safari, or using any of our services, 
              you accept and agree to be bound by these Terms.`,
          image: "",
          provider: {
            "@type": "TravelAgency",
            name: "Joujo Safaris",
            url: "https://joujosafaris.com",
          },
        }}
      />
      <Navbar />
      <section className="privacy-hero">
        <div className="privacy-hero__inner">
          <h1 className="privacy-title"><i className="fas fa-file-contract"></i> Terms of Service</h1>
          <p className="privacy-subtitle">Effective Date: <strong> August 2025</strong></p>
        </div>
      </section>

      <main className="privacy-wrapper">
        <aside className="privacy-toc">
          <h3><i className="fas fa-list-ul"></i> Contents</h3>
          <nav>
            <a href="#acceptance">1. Acceptance of Terms</a>
            <a href="#eligibility">2. Eligibility</a>
            <a href="#bookings">3. Bookings & Payments</a>
            <a href="#cancellations">4. Cancellations & Refunds</a>
            <a href="#conduct">5. Guest Conduct</a>
            <a href="#liability">6. Liability & Disclaimers</a>
            <a href="#health">7. Health & Safety</a>
            <a href="#intellectual">8. Intellectual Property</a>
            <a href="#termination">9. Termination</a>
            <a href="#governing-law">10. Governing Law</a>
            <a href="#changes">11. Changes to Terms</a>
            <a href="#contact">12. Contact Us</a>
          </nav>
        </aside>

        <section className="privacy-content">
          <div className="notice-card info">
            <i className="fas fa-info-circle"></i>
            <p>
              By booking or using Joujo Safaris services, you agree to the following Terms of Service. 
              If you do not agree, please do not use our website or participate in our safaris.
            </p>
          </div>

          <article id="acceptance" className="privacy-block">
            <h2><span>1.</span> Acceptance of Terms</h2>
            <p>
              These Terms of Service constitute a legally binding agreement between Joujo Safaris (“we,” “us,” or “our”) 
              and you (“the client,” “you,” or “your”). By accessing our website, booking a safari, or using any of our services, 
              you accept and agree to be bound by these Terms.
            </p>
          </article>

          <article id="eligibility" className="privacy-block">
            <h2><span>2.</span> Eligibility</h2>
            <ul className="bulleted">
              <li>You must be at least 18 years old to book our services.</li>
              <li>Minors must be accompanied by a parent/guardian who assumes full responsibility.</li>
              <li>You agree to provide accurate, current, and complete information during booking.</li>
            </ul>
          </article>

          <article id="bookings" className="privacy-block">
            <h2><span>3.</span> Bookings & Payments</h2>
            <ul className="checklist">
              <li>All bookings require a deposit or full payment as specified at checkout.</li>
              <li>Payments must be made via our secure payment gateways or approved methods.</li>
              <li>We reserve the right to cancel bookings for unpaid balances.</li>
            </ul>
          </article>

          <article id="cancellations" className="privacy-block">
            <h2><span>4.</span> Cancellations & Refunds</h2>
            <p>Our cancellation policy is as follows:</p>
            <ul className="bulleted">
              <li>Cancellations made 60+ days before the safari: full refund (minus processing fees).</li>
              <li>30–59 days: 50% refund.</li>
              <li>Less than 30 days: non-refundable.</li>
              <li>No-shows: non-refundable.</li>
            </ul>
            <p>Refunds are processed within 14 business days.</p>
          </article>

          <article id="conduct" className="privacy-block">
            <h2><span>5.</span> Guest Conduct</h2>
            <ul className="checklist">
              <li>Respect wildlife, guides, staff, and fellow guests.</li>
              <li>Follow safety instructions at all times.</li>
              <li>No illegal drugs, weapons, or prohibited activities.</li>
              <li>We reserve the right to remove disruptive guests without refund.</li>
            </ul>
          </article>

          <article id="liability" className="privacy-block">
            <h2><span>6.</span> Liability & Disclaimers</h2>
            <p>
              Safaris inherently involve risks, including but not limited to encounters with wildlife, outdoor conditions, 
              and transportation hazards. By booking, you acknowledge these risks and agree that Joujo Safaris is not liable 
              for personal injury, loss, theft, or property damage, except where required by law.
            </p>
          </article>

          <article id="health" className="privacy-block">
            <h2><span>7.</span> Health & Safety</h2>
            <ul className="bulleted">
              <li>Guests must disclose relevant medical conditions prior to the trip.</li>
              <li>Travel insurance with medical coverage is strongly recommended.</li>
              <li>We may refuse participation if we deem it unsafe for your health or others.</li>
            </ul>
          </article>

          <article id="intellectual" className="privacy-block">
            <h2><span>8.</span> Intellectual Property</h2>
            <p>
              All website content, itineraries, images, and branding are the property of Joujo Safaris 
              and may not be copied, distributed, or used without written consent.
            </p>
          </article>

          <article id="termination" className="privacy-block">
            <h2><span>9.</span> Termination</h2>
            <p>
              We may suspend or terminate access to our services for violations of these Terms, 
              fraudulent activity, or unsafe conduct.
            </p>
          </article>

          <article id="governing-law" className="privacy-block">
            <h2><span>10.</span> Governing Law</h2>
            <p>
              These Terms shall be governed by and construed under the laws of Kenya (or applicable jurisdiction), 
              without regard to conflict of law provisions.
            </p>
          </article>

          <article id="changes" className="privacy-block">
            <h2><span>11.</span> Changes to Terms</h2>
            <p>
              We reserve the right to update these Terms at any time. Changes will be effective upon posting. 
              Continued use of our services after updates constitutes acceptance.
            </p>
          </article>

          <article id="contact" className="privacy-block">
            <h2><span>12.</span> Contact Us</h2>
            <div className="card contact-card">
              <p><i className="fas fa-building"></i> <strong>Joujo Safaris</strong></p>
              <p><i className="fas fa-envelope"></i> <a href="mailto:support@joujosafaris.com">support@joujosafaris.com</a></p>
              <p><i className="fas fa-phone"></i> <a href="tel:+254729864933">+254729864933</a></p>
              <p><i className="fas fa-map-marker-alt"></i> [Nairobi, Kenya]</p>
            </div>
          </article>

          <p className="last-updated"><i className="far fa-clock"></i> Last updated: August 2025</p>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Terms;
